export const JuryList = [
  {
    imgSrc: require('../images/expert/typeA/崔君杰.jpg'),
    name: '崔君杰',
    company: '上海翩玄私募基金管理有限公司',
    title: '董事长',
  },
  {
    imgSrc: require('../images/expert/typeA/戴更辉.jpg'),
    name: '戴更辉',
    company: '启赋资本',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/杜豫川.jpg'),
    name: '杜豫川',
    company: '同济大学',
    title: '科研管理部副部长',
  },
  {
    imgSrc: require('../images/expert/typeA/范天豪.jpg'),
    name: '范天豪',
    company: '上海申康医院发展中心',
    title: '市级医院成果转化负责人',
  },
  {
    imgSrc: require('../images/expert/typeA/方曦.jpg'),
    name: '方曦',
    company: '上海应用技术大学中欧知识产权促进中心',
    title: '常务副主任',
  },
  {
    imgSrc: require('../images/expert/typeA/胡斌.jpg'),
    name: '胡斌',
    company: '幂方健康基金',
    title: '执行董事',
  },
  {
    imgSrc: require('../images/expert/typeA/胡斐.jpg'),
    name: '胡斐',
    company: '天势资本',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/黄文娜.jpg'),
    name: '黄文娜',
    company: '龙磐投资',
    title: '董事',
  },
  {
    imgSrc: require('../images/expert/typeA/嵇轶伦.jpg'),
    name: '嵇轶伦',
    company: '中科优势',
    title: '投资副总裁',
  },
  {
    imgSrc: require('../images/expert/typeA/季聿捷.jpg'),
    name: '季聿捷',
    company: '璞跃中国',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/姜明达.jpg'),
    name: '姜明达',
    company: '苏州工业园区元禾原点创业投资管理有限公司',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/蒋骏航.jpg'),
    name: '蒋骏航',
    company: '上海生物医药产业股权投资基金管理有限公司',
    title: '总监',
  },
  {
    imgSrc: require('../images/expert/typeA/金振宇.jpg'),
    name: '金振宇',
    company: '九合创投',
    title: '投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/雷达.jpg'),
    name: '雷达',
    company: '清创汇智创新创业研究院',
    title: '理事',
  },
  {
    imgSrc: require('../images/expert/typeA/李墨.jpg'),
    name: '李墨',
    company: '常见投资',
    title: '投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/李楠.jpg'),
    name: '李楠',
    company: '中信建投资本',
    title: '高级副总裁',
  },
  {
    imgSrc: require('../images/expert/typeA/梁峰.jpg'),
    name: '梁峰',
    company: '今日人工智能',
    title: '联合创始人兼首席架构师',
  },
  {
    imgSrc: require('../images/expert/typeA/廖应川.jpg'),
    name: '廖应川',
    company: '清汇创投',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/林惠君.jpg'),
    name: '林惠君',
    company: '清汇创投',
    title: '创始人',
  },
  {
    imgSrc: require('../images/expert/typeA/刘海涛.jpg'),
    name: '刘海涛',
    company: '中国科学院上海高等研究院',
    title: '知识产权规划布局主管',
  },
  {
    imgSrc: require('../images/expert/typeA/刘璐英.jpg'),
    name: '刘璐英',
    company: '上海技术交易所生物医药专板运营中心',
    title: '总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/刘思卿.jpg'),
    name: '刘思卿',
    company: '上海东洲资产评估有限公司',
    title: '总裁助理、资产评估师',
  },
  {
    imgSrc: require('../images/expert/typeA/刘文溢.jpg'),
    name: '刘文溢',
    company: '杏泽投资',
    title: '创始合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/龙毅.jpg'),
    name: '龙毅',
    company: '四川大学科产集团',
    title: '副总经理兼大学科技园总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/卢飞.jpg'),
    name: '卢飞',
    company: '源渡创投',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/马婷.png'),
    name: '马婷',
    company: '小苗朗程',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/莫剑英.jpg'),
    name: '莫剑英',
    company: '上海市高校科技发展中心，原上海海事大学技术转移中心',
    title: '顾问，副处长',
  },
  {
    imgSrc: require('../images/expert/typeA/莫学斌.jpg'),
    name: '莫学斌',
    company: '赤道基金',
    title: '合伙人、董事',
  },
  {
    imgSrc: require('../images/expert/typeA/穆泽林.jpg'),
    name: '穆泽林',
    company: '天势资本',
    title: '创始人',
  },
  {
    imgSrc: require('../images/expert/typeA/邱军.jpg'),
    name: '邱军',
    company: '北京市柳沈律师事务所',
    title: '合伙人 律师 专利代理师',
  },
  {
    imgSrc: require('../images/expert/typeA/宋俊典.jpg'),
    name: '宋俊典',
    company: '上海计算机软件技术开发中心',
    title: '副主任',
  },
  {
    imgSrc: require('../images/expert/typeA/宋缨.jpg'),
    name: '宋缨',
    company: '上海泰能知识产权代理事务所',
    title: '主任合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/田丰.jpg'),
    name: '田丰',
    company: '上海医药行业协会',
    title: '产学研医创新转化专委会常务副主任委员兼秘书长',
  },
  {
    imgSrc: require('../images/expert/typeA/谭刚.jpg'),
    name: '谭刚',
    company: '浙江大学',
    title: '长三角智慧绿洲创新中心智能绿建创新实验室主任',
  },
  {
    imgSrc: require('../images/expert/typeA/王枫.jpg'),
    name: '王枫',
    company: '旌珩科技（上海）有限公司',
    title: '总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/王海涛.jpg'),
    name: '王海涛',
    company: '上海航天技术基础研究所',
    title: '高级工程师',
  },
  {
    imgSrc: require('../images/expert/typeA/王荟.jpg'),
    name: '王荟',
    company: '中关村天使投资协会',
    title: '执行秘书长',
  },
  {
    imgSrc: require('../images/expert/typeA/王剑华.jpg'),
    name: '王剑华',
    company: '中科先进产业基金',
    title: '执行董事',
  },
  {
    imgSrc: require('../images/expert/typeA/王科力.jpg'),
    name: '王科力',
    company: '硅化硅基',
    title: '首席财务官',
  },
  {
    imgSrc: require('../images/expert/typeA/王昆.jpg'),
    name: '王昆',
    company: '力合科创（苏州）',
    title: '投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/王立言.jpg'),
    name: '王立言',
    company: '上海临床创新转化研究院',
    title: '副总裁',
  },
  {
    imgSrc: require('../images/expert/typeA/王旻骏.jpg'),
    name: '王旻骏',
    company: '辰德资本',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/王维.jpg'),
    name: '王维',
    company: '启迪之星',
    title: '副总裁',
  },
  {
    imgSrc: require('../images/expert/typeA/王玉叶.png'),
    name: '王玉叶',
    company: '经纬创投',
    title: '资深投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/王晢金.jpg'),
    name: '王晢金',
    company: '杭州方正多策私募基金',
    title: '总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/吴军生.jpg'),
    name: '吴军生',
    company: '上海利彤创业投资有限公司',
    title: '董事长',
  },
  {
    imgSrc: require('../images/expert/typeA/吴燕敏.jpg'),
    name: '吴燕敏',
    company: '上海专利商标事务所',
    title: '首席顾问',
  },
  {
    imgSrc: require('../images/expert/typeA/熊申展.jpg'),
    name: '熊申展',
    company: '华东师范大学',
    title: '处长助理',
  },
  {
    imgSrc: require('../images/expert/typeA/熊星驰.jpg'),
    name: '熊星驰',
    company: '华胜资本',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/徐荣.jpg'),
    name: '徐荣',
    company: '科创界TechIn',
    title: '创始人',
  },
  {
    imgSrc: require('../images/expert/typeA/徐源吉.jpg'),
    name: '徐源吉',
    company: '启赋私募基金管理有限公司',
    title: '高级投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/杨海忠.jpg'),
    name: '杨海忠',
    company: '小苗基金',
    title: '副总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/杨靖奕.jpg'),
    name: '杨靖奕',
    company: '苍竹资本',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/叶小云.jpg'),
    name: '叶小云',
    company: '清创汇智创新创业研究院',
    title: '理事长',
  },
  {
    imgSrc: require('../images/expert/typeA/殷曙帆.jpg'),
    name: '殷曙帆',
    company: '遨问创投',
    title: '投资经理',
  },
  {
    imgSrc: require('../images/expert/typeA/尹占宏.png'),
    name: '尹占宏',
    company: '源起科创（北京）基金',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/曾飘.jpg'),
    name: '曾飘',
    company: '医睿星资本',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/张建忠.jpg'),
    name: '张建忠',
    company: '上海医药集团股份有限公司',
    title: '研发管理中心资深专家',
  },
  {
    imgSrc: require('../images/expert/typeA/张晨曦.jpg'),
    name: '张晨曦',
    company: '上海科转技鑫私募基金管理有限公司',
    title: '总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/张春雁.jpg'),
    name: '张春雁',
    company: '上海中医药大学附属岳阳中西医结合医院',
    title: '科研处处长',
  },
  {
    imgSrc: require('../images/expert/typeA/张平.jpg'),
    name: '张平',
    company: '上海空间电源研究所科技委',
    title: '副主任',
  },
  {
    imgSrc: require('../images/expert/typeA/赵颖文.jpg'),
    name: '赵颖文',
    company: '上海昊君投资管理有限公司',
    title: '总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/仲实.jpg'),
    name: '仲实',
    company: '复旦大学',
    title: '科研院技术转移中心主任',
  },
  {
    imgSrc: require('../images/expert/typeA/郑浩.png'),
    name: '郑浩',
    company: '启赋资本',
    title: '董事总经理',
  },
  {
    imgSrc: require('../images/expert/typeA/钟天杰.jpg'),
    name: '钟天杰',
    company: '真格基金',
    title: '投资总监',
  },
  {
    imgSrc: require('../images/expert/typeA/周昌艳.jpg'),
    name: '周昌艳',
    company: '上海市农业科学院',
    title: '成果转化处处长（研究员）',
  },
  {
    imgSrc: require('../images/expert/typeA/周蕾.jpg'),
    name: '周蕾',
    company: '驭本资本',
    title: '合伙人',
  },
  {
    imgSrc: require('../images/expert/typeA/朱亦卿.jpg'),
    name: '朱亦卿',
    company: '元璟资本',
    title: '投资副总裁',
  },
  {
    imgSrc: require('../images/expert/typeA/邹涛.jpg'),
    name: '邹涛',
    company: '中科优势',
    title: '创始合伙人',
  }
]

export const MajorJuryList = [









 
 


]
